import { MultiSelectComponentProps } from "@eworkit/iris";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { IHttpRequestConfig } from "@/browser";
import { useInfiniteOptions } from "@/components-new/select";
import {
  fetchConsultantProfileManagerList,
  IConsultantProfile,
  IFetchConsultantProfilesListParams,
} from "@/data/consultant-profiles";
import { ConsultantMultiSelect } from "@/views/components/Selects/Consultant";

export interface ManagerMultiTypeaheadProps extends MultiSelectComponentProps<IConsultantProfile> {
  companyId: number;
}

const fetchData = async (params?: IFetchConsultantProfilesListParams, options?: IHttpRequestConfig) =>
  await fetchConsultantProfileManagerList(params, options);

export const ManagerMultiTypeahead: FC<ManagerMultiTypeaheadProps> = ({
  companyId,
  ...props
}: ManagerMultiTypeaheadProps) => {
  const { handleQueryChange, fetchNextPage, selectOptions, working } = useInfiniteOptions({
    queryKey: ["manager", "typeahead"],
    fetchData,
    params: {
      size: 30,
      companyId,
    },
    options: {
      staleTime: Infinity,
    },
  });
  const { t } = useTranslation("session");

  const onEndReached = () => {
    if (!working) {
      fetchNextPage();
    }
  };

  return (
    <ConsultantMultiSelect
      ariaOptionsLabel="options-list"
      placeholder={t("COMPONENTS.TYPEAHEAD.EXTERNAL_SUPPLIERS.SINGLE_PLACEHOLDER")}
      onQueryChange={handleQueryChange}
      options={selectOptions}
      working={working}
      onEndReached={onEndReached}
      {...props}
    />
  );
};
